import React from "react";
import { useDispatch } from "react-redux";

import { toDate } from "~/tools/date-time";
import type { ClockTimeFormat } from "~/tools/date-time/format/clock-time-format";
import type { Time } from "~/tools/date-time/time";

import { timelineUpdateRequested } from "../../../app/state/view/timeline/TimelineActions";
import { HighlightTimestampCursor } from "../../TimestampCursor";
import { InlineLink } from "../styled/StyledComponents";
import { FormatViewTime } from "../viewtime/FormatViewTime";

export interface ViewTimeLinkProps {
	time: Time;
	className?: string;
	clockTimeFormat?: ClockTimeFormat;
}

/**
 * Makes a clickable link to jump to a time.
 * If the view is currently in live mode the time will be displayed in relative time (e.g. 5 minutes ago).
 * Otherwise the time will be shown in absolute time.
 */
export const ViewTimeLink: React.FC<ViewTimeLinkProps> = ({ time: timestamp, clockTimeFormat, ...restProps }) => {
	const dispatch = useDispatch();

	const handleClick = (e: React.MouseEvent): void => {
		e.preventDefault();
		e.stopPropagation();
		dispatch(timelineUpdateRequested({ timestamp: toDate(timestamp) }));
	};

	return (
		<HighlightTimestampCursor
			el={InlineLink}
			onClick={handleClick}
			shouldSetCursor
			timestamp={timestamp}
			{...restProps}
		>
			<FormatViewTime clockTimeFormat={clockTimeFormat} time={timestamp} />
		</HighlightTimestampCursor>
	);
};
